<template>
	<div id="product-model-info">
		<!-- 面包屑 -->
		<div class="func-bar" v-if="selectedModel != null">
			<div class="center-common-breadcrumb">
				<!-- <span v-if="type != null">{{ cur_lang == "zh" ? type.nameCh : type.nameEn }}</span>
				<span style="width: 20px; text-align: center;" v-if="type != null">/</span> -->
				<span style="font-weight: bold; cursor: pointer;" @click="backtoProductList"
					v-if="type != null">{{ cur_lang == "zh" ? type.nameCh : type.nameEn }}</span>
				<span style="width: 20px; text-align: center;" v-if="type != null">/</span>
				<span style="font-weight: bold; cursor: pointer;" @click="backtoProductModelList"
					v-if="selectedModel != null">{{ selectedModel.model }}
				</span>
				<span style="width: 20px; text-align: center;" v-if="selectedModel != null">/</span>
				<span>{{ cur_lang == "zh" ? "型号信息" : "Model info." }}</span>
			</div>
			<!-- 联系信息 -->
			<div class="down">
				<el-button type="primary" @click="dialogVisible = true">{{
					$t("contact_info")
				}}</el-button>
				<!-- <el-button type="primary" @click="copyBtnClick">{{
		  $t("copy_info")
		}}</el-button> -->
			</div>
		</div>
		<div class="info-header" v-if="selectedModel != null">
			<!-- 左边图片 -->
			<div class="info-header-left">
				<el-image style="width: 90%;" fit="contain" :src="imageBaseURL + selectedModel.materialUrl + '?reduce=true'"
					:preview-src-list="[imageBaseURL + selectedModel.materialUrl]"></el-image>
			</div>
			
			<!-- 右边简介 -->
			<div class="info-header-right">
				<!-- 型号 -->
				<div class="common-style">
					<span style="font-weight: bold; margin-right: 10px;">{{ $t("product_info.model") }}:</span>
					<span style="font-weight: bold; font-size: 20px;">{{ selectedModel.model }}</span>
				</div>
				<!-- 时间 -->
				<!-- <div class="common-style">
					<span style="font-weight: bold; margin-right: 10px;">{{ $t("product_info.date") }}:</span>
					<span>{{ selectedModel.created_at.substr(0, 10) }}</span>
				</div> -->
				<!-- 描述 -->
				<div class="common-style">
					<span style="font-weight: bold; margin-right: 10px;">{{ $t("product_info.summary") }}:</span>
					<span>{{
            cur_lang == "zh"
              ? selectedModel.synopsisCh
              : selectedModel.synopsisEn
          }}</span>
				</div>
			</div>
		</div>

		<div class="content" style="padding: 5px;" v-if="selectedModel != null">
			<!-- 用途 -->
			<div class="purpose common-section">
				<div class="common-section-title">{{ $t("product_info.use") }}</div>
				<div class="purpose-tags">
					<span class="purpose-tag" v-for="(item, index) in selectedModel.tag"
						:key="index">{{ cur_lang == "zh" ? item.nameCh : item.nameEn }}</span>
				</div>
			</div>
			<!-- 结构图 -->
			<div class="struct-images common-section">
				<div class="common-section-title">
					{{ $t("product_info.structure_diagram") }}
				</div>
				<el-image style="width: 270px; margin: 10px;"
					v-for="(imageUrl, index) in JSON.parse(selectedModel.structureUrl)" :key="index"
					:src="imageBaseURL + imageUrl + '?reduce=true'" :preview-src-list="preList">
				</el-image>
				<span style="height: 25px;"
					v-if="JSON.parse(selectedModel.structureUrl).length == 0">{{ $t("nodata") }}</span>
			</div>
			<!-- 参数 -->
			<div class="parmares common-section">
				<div class="common-section-title">
					{{ $t("product_info.parameters") }}
				</div>
				<div style="text-align: left; padding: 10px;">
					<el-table :data="JSON.parse(selectedModel.target)" stripe border>
						<el-table-column :label="$t('product_info.parameter_key')">
							<div slot-scope="scope" class="paramer-table">
								{{ cur_lang == "zh" ? scope.row.nameCh : scope.row.nameEn }}
							</div>
						</el-table-column>

						<el-table-column :label="$t('product_info.parameter_value')">
							<div slot-scope="scope" class="paramer-table">
								{{ scope.row.value }}
							</div>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>

		<el-dialog :title="$t('contact_info')" :visible.sync="dialogVisible" width="40%" v-if="contactUsInfo != null">
			<!-- 公司名 -->
			<div class="dialog-section">
				<span style="font-weight: bold; margin-right: 15px;">{{ $t("company_info.company_name") }}:</span>
				<span>{{ cur_lang == "zh" ? contactUsInfo.nameCh : contactUsInfo.nameEn }}</span>
			</div>
			<!-- 公司地址 -->
			<div class="dialog-section">
				<span style="font-weight: bold; margin-right: 15px;">{{ $t("company_info.company_address") }}:</span>
				<span>{{
          cur_lang == "zh" ? contactUsInfo.addressCh : contactUsInfo.addressEn
        }}</span>
			</div>
			<!-- 销售热线 -->
			<div class="dialog-section">
				<span style="font-weight: bold; margin-right: 15px;">{{ $t("company_info.sales_hotline") }}:</span>
				<span>{{
          cur_lang == "zh" ? contactUsInfo.service : contactUsInfo.service
        }}</span>
			</div>
			<!-- 公司总机 -->
			<div class="dialog-section">
				<span
					style="font-weight: bold; margin-right: 15px;">{{ $t("company_info.company_switchboard") }}:</span>
				<span>{{
          cur_lang == "zh" ? contactUsInfo.phone : contactUsInfo.phone
        }}</span>
			</div>
			<!-- 业务联系 -->
			<div class="dialog-section">
				<span style="font-weight: bold; margin-right: 15px;">{{ $t("company_info.business_contact") }}:</span>
				<span>{{
          cur_lang == "zh" ? contactUsInfo.businessCh : contactUsInfo.businessEn
        }}</span>
			</div>
			<!-- 官方网站 -->
			<div class="dialog-section">
				<span style="font-weight: bold; margin-right: 15px;">{{ $t("company_info.official_website") }}:</span>
				<span>http://www.chinesesensor.com</span>
			</div>
			<!-- 传真 -->
			<div class="dialog-section">
				<span style="font-weight: bold; margin-right: 15px;">{{ $t("company_info.fax") }}:</span>
				<span>{{
          cur_lang == "zh" ? contactUsInfo.fax : contactUsInfo.fax
        }}</span>
			</div>
			<!-- 邮箱 -->
			<div class="dialog-section">
				<span style="font-weight: bold; margin-right: 15px;">{{ $t("company_info.email") }}:</span>
				<span>{{
          cur_lang == "zh" ? contactUsInfo.emailCh : contactUsInfo.emailEn
        }}</span>
			</div>

			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="dialogVisible = false">{{ $t("cancel") }}</el-button> -->
				<el-button type="primary" @click="dialogVisible = false">{{
          $t("sure")
        }}</el-button>
			</span>
		</el-dialog>

		<el-footer></el-footer>
	</div>
</template>

<script>
	export default {
		name: "ProductModelInfo",
		data() {
			return {
				type: null,
				selected_type_index: 0,
				selected_sub_type_index: 0,
				product_id: '',
				model_id: '',
				// 产品
				product: null,
				// 产品型号
				selectedModel: null,
				dialogVisible: false,
				cur_lang: "zh",
				contactUsInfo: null,

				preList: [],
			};
		},

		created() {
			// 当前语言
			let cur_lang = localStorage.getItem("locale");
			if (cur_lang) {
				this.cur_lang = cur_lang
			}

			// 通过复制链接，本地没有缓存
			// 获取链接从?号开始的参数,如:  ?a=1&b=2
			let url = location.search;
			// 去除问号
			let str = url.substr(1);
			// 分离参数
			let strArray = str.split("&");

			// 解码参数，获取型号信息
			this.selected_type_index = decodeURIComponent(strArray[0].replace("type_index=", ""));
			this.selected_type_sub_index = decodeURIComponent(strArray[1].replace("type_sub_index=", ""));
			this.product_id = decodeURIComponent(strArray[2].replace("product_id=", ""));
			this.model_id = decodeURIComponent(strArray[3].replace("model_id=", ""));

			// 获取当前二级分类
			this.getCurSubType();
			// 获取型号信息
			this.searchProductModel(this.model_id);
			let that = this;
			setTimeout(function() {
				that.contactUsInfo = JSON.parse(sessionStorage.getItem('contact_info'));
			}, 2000);
		},

		mounted() {
			const that = this;
			window.addEventListener("setItem", function(e) {
				// console.log('molde info 监听到了', e.key, e.newValue)
				if (e.key == 'locale') {
					that.cur_lang = e.newValue;
				} else if (e.key == 'all_product_type_list') {
					// 监听到获取完所有类型，获取当前的二级分类
					that.getCurSubType();
				}
			});
		},

		methods: {

			getCurSubType: function() {

				let typesJson = sessionStorage.getItem('all_product_type_list');
				if (typesJson == null) return;
				
				let types = JSON.parse(typesJson);
				if (types.length == 0) return;

				// 根据下标找到对应的一级大类
				let type = types[this.selected_type_index];
				if (type.child.length == 0) return;

				// 根据下标找到对应的二级分类
				this.type = type.child[this.selected_type_sub_index];
			},

			// 处理结构图
			dealStructUrl: function() {

				let originPreUrls = JSON.parse(this.selectedModel.structureUrl);
				// 处理结构图
				for (var i = 0; i < originPreUrls.length; i++) {
					let preUrl = this.imageBaseURL + originPreUrls[i];
					// console.log('结构图：', preUrl);
					this.preList.push(preUrl);
				}

			},

			searchProductModel: function(model_id) {
				let url = "api/product/getModelInfo?id=" + model_id;
				let that = this;
				this.$utils.httpRequestGet(
					url,
					null,
					function success(res) {
						that.selectedModel = res.data;
						// 处理结构图
						that.dealStructUrl();

					},
					function fail(res) {
						console.log('失败：' + res.msg)
					}
				);
			},

			backtoProductList: function() {
				// if (window.history.length > 2) {
				// window.history.go(-2);
				// }

				window.location.href = 'product.html?type_index=' + this.selected_type_index + '&type_sub_index=' +
					this.selected_type_sub_index;
			},

			backtoProductModelList: function() {

				// 当前页面历史链接数, 暂且认为小于4则属于通过复制链接进入
				// if (window.history.length > 3) {
				// 	window.history.back();
				// }
				window.location.href = 'productcentermodel.html?type_index=' + this.selected_type_index +
					'&type_sub_index=' + this.selected_type_sub_index + '&product_id=' + this.product_id;
			},

		}
	};
</script>

<style>
	#product-model-info {
		width: 100%;
	}

	#product-model-info .func-bar {
		width: 100%;
		min-height: 50px;
		font-size: 20px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;

		border-bottom: 1px solid #cccccc;
	}

	.center-common-breadcrumb {
		width: 65%;
		height: 100%;
		font-size: 18px;
		margin-left: 10px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}

	#product-model-info .info-header {
		margin: 10px;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}

	.info-header .info-header-left {
		width: 200px;
		height: 200px;
		border: 1px solid #2c3e50;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.info-header .info-header-right {
		width: 600px;
		height: 200px;
		text-align: left;
		margin-left: 10px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		/* background-color: #163E87; */
	}

	.info-header-right .common-style {
		padding-left: 10px;
		padding-top: 5px;
		padding-right: 5px;
	}

	.header-right .descri {
		text-align: left;
		word-break: break-word;
		overflow: hidden;
		text-overflow: ellipsis;

		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.info-header-right .down {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
		padding-right: 10px;
	}

	.common-section {
		margin-top: 15px;
		margin-bottom: 15px;
	}

	.common-section-title {
		background-color: #d2deee;
		border-radius: 5px;
		line-height: 40px;
		text-align: left;
		color: #2c3e50;
		padding-left: 5px;
		font-size: 18px;
		font-weight: bold;
	}

	.content .purpose-tags {
		text-align: left;
		padding: 10px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
	}

	.purpose-tags .purpose-tag {
		margin-left: 15px;
		margin-top: 10px;
		padding: 5px;
		border: 1px solid #cccccc;
		/* box-shadow: 2px 2px 2px #CCCCCC; */
		border-radius: 5px;
	}

	.dialog-section {
		margin-top: 5px;
		text-align: left;
		width: 100%;
	}
	
	
</style>
